export default __webpack_public_path__ + "static/media/discount-codes.70973e18.svg";